<template>
    <div class="flex items-center justify-end space-x-4" v-if="editing">
        <template>
            <ui-button-new small icon="fa fa-undo"
                           @click="undo"
                           @mousedown="disableStateTracking"
                           :disabled="undosAvailable()?false:true"
                           v-if="editing"
            >Undo {{ undosAvailable() ? '(' + undosAvailable() + ')' : '' }}
            </ui-button-new>
            <ui-button-new small icon="fa fa-repeat"
                           @click="redo"
                           @mousedown="disableStateTracking"
                           :disabled="redosAvailable()?false:true"
                           v-if="editing"
            >Redo {{ redosAvailable() ? '(' + redosAvailable() + ')' : '' }}
            </ui-button-new>
            <div class="flex">
                <ui-dropdown placement="bottom-end" menu-class="p-3 w-72" :key="userKey">
                    <template #default="{ toggle }">
                        <ui-button-new @click="toggle" small primary>
                            Actions
                            <i class="flex-shrink-0 ml-2 fa fa-chevron-down"></i>
                        </ui-button-new>
                    </template>
                    <template #menu="{ close }">
                        <ui-dropdown-item icon="fas fa-file-import" @click="$emit('importEstimate')">Import from
                            Estimate
                        </ui-dropdown-item>
                    </template>
                </ui-dropdown>
            </div>
        </template>
    </div>
</template>

<script>
import {ContractedWorks} from "../../../models";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";

export default {
    components: {UiDropdownDivider, UiButtonNew, UiDropdownItem},
    props: {
        contractedWorks: ContractedWorks,
        sections: Array,
        editing: false,
        user: Object,
    },
    data() {
        return {
            states: [],
            position: 0,
            selectedPage: [],
            userKey: 1,
        }
    },
    watch: {
        editing: {
            handler(newValue, oldValue) {
                this.contractedWorks.clearSnapshots(0);
                this.contractedWorks.addSnapshot();
                this.states = this.contractedWorks.getSnapshotStore().states;
                this.position = this.states.length - 1;
            },
        },
    },
    computed: {},
    methods: {
        undosAvailable() {
            return this.states.length - this.redosAvailable() - 1
        },
        redosAvailable() {
            return this.states.length - this.position - 1
        },
        disableStateTracking() {
            document.activeElement.blur();
        },
        undo() {
            Object.assign(this.contractedWorks.proposal, JSON.parse(this.states[--this.position]))
            this.contractedWorks.updateProposal(this.contractedWorks.getProposal());
            this.$emit('reflow')
        },
        redo() {
            Object.assign(this.contractedWorks.proposal, JSON.parse(this.states[++this.position]))
            this.contractedWorks.updateProposal(this.contractedWorks.getProposal());
            this.$emit('reflow')
        },
    },
    mounted() {
        eventBus.$on('contracted-works-history-state-updated', (data) => {
            if (data.contractedWorks === this.contractedWorks) {
                if (this.position + 1 !== data.states.length - 1) {
                    this.contractedWorks.clearSnapshots(this.position + 1, data.states.length - this.position - 2);
                    data = this.contractedWorks.getSnapshotStore();
                    this.states = data.states
                    this.position = data.states.length - 1;
                    this.$forceUpdate();
                } else {
                    this.states = data.states
                    this.position = data.states.length - 1;
                }
            }
        });
        if (this.editing) {
            this.contractedWorks.clearSnapshots(0);
            this.contractedWorks.addSnapshot();
            this.states = this.contractedWorks.getSnapshotStore().states;
            this.position = this.states.length - 1;
        }
    }
}
</script>
